import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Link } from "react-router-dom";
import styled from "styled-components";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CustomeLoader from "../../components/CustomeLoader";
import { CCard, CCardHeader } from "@coreui/react";
import Swal from "sweetalert2";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Paper } from "@mui/material";

const PurchasePayment = () => {
  const [payments, setPayments] = useState([]);
  const [pending, setPending] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  useEffect(() => {
    axios
      .get("https://dawabajar.encantotech.in/api/purchase-payment/list")
      .then((res) => {
        res.data.status === 200 ? setPayments(res.data.data) : setPayments([]);
      })
      .catch((err) => {
        Toast.fire({
          icon: "error",
          title: "Error fetching payments",
        });
      })
      .finally(() => {
        setPending(false);
      });
  }, []);

  const deleteHandler = (row) => {
    Swal.fire({
      html: "Are you sure you wish to<br /> delete this payment?",
      showCancelButton: true,
      confirmButtonColor: "#1D718B",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      customClass: {
        confirmButton: "swal-confirm-button",
        cancelButton: "swal-cancel-button",
      },
      width: "350",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(
            `https://dawabajar.encantotech.in/api/purchase-payment/delete/${row.id}`
          )
          .then((result) => {
            Toast.fire({
              icon: "success",
              title: result.data.message,
            });
            setPayments(payments.filter((item) => item.id !== row.id));
          })
          .catch((error) => {
            Toast.fire({
              icon: "error",
              title: "Error deleting payment",
            });
          });
      }
    });
  };

  const viewHandler = (row) => {
    axios
      .get(
        `https://dawabajar.encantotech.in/api/purchase-payment-details/${row.id}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setSelectedPayment(res.data.data);
          setOpenDialog(true);
        }
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error fetching payment details",
        });
      });
  };

  const columns = [
    {
      name: "#",
      selector: (row, index) => <div>{index + 1}</div>,
      width: "100px",
    },
    {
      name: "Type",
      selector: (row) => row.type || "Not available",
      width: "150px",
    },
    {
      name: "Amount",
      selector: (row) => row.amount || "Not available",
      width: "150px",
    },
    {
      name: "Due",
      selector: (row) => row.due || "Not available",
      width: "150px",
    },
    {
      name: "Supplier ID",
      selector: (row) => row.supplier_id || "Not available",
      width: "150px",
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks || "Not available",
      width: "200px",
    },
    {
      name: "Action",
      selector: (row) => (
        <div style={{ display: "flex", gap: "4px" }}>
          <Link
            to={`/edit-purchase-payment/${row.id}`}
            className="btn btn-primary m-1"
            style={{
              padding: "6px 12px",
              backgroundColor: "#1976d2",
              border: "none",
            }}
          >
            <EditIcon fontSize="small" />
          </Link>
          <button
            className="btn btn-danger m-1"
            onClick={() => deleteHandler(row)}
            style={{
              padding: "6px 12px",
              backgroundColor: "#d32f2f",
              border: "none",
            }}
          >
            <DeleteIcon fontSize="small" />
          </button>
          <button
            className="btn m-1"
            onClick={() => viewHandler(row)}
            style={{
              padding: "6px 12px",
              backgroundColor: "#0288d1",
              color: "white",
              border: "none",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#0277bd",
              },
            }}
          >
            <VisibilityIcon fontSize="small" />
          </button>
        </div>
      ),
      width: "200px",
      sortable: false,
    },
  ];

  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("status")) {
      navigate("/");
    }
  }, [navigate]);

  const TextField = styled.input`
    height: 32px;
    width: 200px;
    border-radius: 3px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid #e5e5e5;
    padding: 0 32px 0 16px;
    &:hover {
      cursor: pointer;
    }
  `;

  const filteredItems = payments.filter(
    (item) =>
      (item.type &&
        item.type.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.amount &&
        item.amount.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.due && item.due.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.supplier_id &&
        item.supplier_id.toString().includes(filterText.toLowerCase())) ||
      (item.remarks &&
        item.remarks.toLowerCase().includes(filterText.toLowerCase()))
  );

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-2 p-0">
            <Sidebar />
          </div>
          <div className="col-sm-10">
            <div className="container-fluid">
              <Navbar />
              <CCard className="mb-4 ml-3">
                <CCardHeader>
                  <strong>Purchase Payments</strong>
                </CCardHeader>
                <div className="customerContainer">
                  <div className="container">
                    <div className="row">
                      <div className="col-sm-6 mt-1">
                        <TextField
                          type="text"
                          placeholder="Search...."
                          value={filterText}
                          autoFocus
                          onChange={(e) => setFilterText(e.target.value)}
                        />
                        <button
                          className="btn btn-primary m-1"
                          onClick={handleClear}
                        >
                          X
                        </button>
                      </div>
                      <div className="col-sm-6">
                        <div className="mt-2 text-right">
                          <Link
                            to="/add-purchase-payment"
                            className="btn btn-primary mr-5"
                          >
                            + Add New
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="m-1">
                      <DataTable
                        columns={columns}
                        data={filteredItems}
                        defaultSortFieldId
                        fixedHeaderScrollHeight="480px"
                        fixedHeader
                        responsive
                        pagination={10}
                        subHeaderAlign="right"
                        highlightOnHover
                        progressPending={pending}
                        progressComponent={<CustomeLoader />}
                      />
                    </div>
                  </div>
                </div>
              </CCard>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        PaperProps={{
          component: Paper,
          elevation: 3,
          style: {
            minWidth: "400px",
            borderRadius: "8px",
            padding: "16px",
          },
        }}
      >
        <DialogTitle
          style={{
            backgroundColor: "#1976d2",
            color: "white",
            padding: "16px",
            borderRadius: "8px 8px 0 0",
            fontWeight: "bold",
          }}
        >
          Payment Details
        </DialogTitle>
        <DialogContent style={{ padding: "24px" }}>
          {selectedPayment && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                fontSize: "16px",
              }}
            >
              <p style={{ margin: 0 }}>
                <strong>ID:</strong> {selectedPayment.id}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Type:</strong> {selectedPayment.type}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Amount:</strong> {selectedPayment.amount}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Due:</strong> {selectedPayment.due}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Supplier ID:</strong> {selectedPayment.supplier_id}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Remarks:</strong> {selectedPayment.remarks}
              </p>
              {/* <p style={{ margin: 0 }}>
                <strong>Created At:</strong> {selectedPayment.created_at}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Updated At:</strong> {selectedPayment.updated_at}
              </p> */}
            </div>
          )}
        </DialogContent>
        <DialogActions style={{ padding: "0 24px 16px" }}>
          <Button
            onClick={() => setOpenDialog(false)}
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#1976d2",
              textTransform: "none",
              padding: "8px 16px",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PurchasePayment;
